// components/PhoneNumberInput.js
import React, { useRef } from "react";

function PhoneNumberInput({
  phoneNumber,
  phoneFirstOptions,
  handlePhoneNumberChange,
  formFieldColor,
  treatments,
  btnSize22,
}) {
  const secondInputRef = useRef(null); // `third` 입력 필드에 대한 ref
  const thirdInputRef = useRef(null); // `third` 입력 필드에 대한 ref

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const numericValue = value.replace(/[^0-9]/g, "");

    // 핸들러 호출
    handlePhoneNumberChange(e);

    // 숫자 4개 입력 시 다음 필드로 포커스 이동
    if (name === "first" && numericValue.length === 3) {
      secondInputRef.current.focus(); // `ref`를 사용해 포커스 이동
    }
    // 숫자 4개 입력 시 다음 필드로 포커스 이동
    if (name === "second" && numericValue.length === 4) {
      thirdInputRef.current.focus(); // `ref`를 사용해 포커스 이동
    }
  };

  return (
    <div
      className={`formField ${formFieldColor === "white" ? "white" : ""}`}
      style={btnSize22 ? { width: "75%" } : undefined}
    >
      {" "}
      {treatments ? "" : <label htmlFor="phoneFirst">연락처</label>}
      <div className="phoneNumberInput">
        {/* <div className="selectWrapper"> */}
        {/* <select
            id="phoneFirst"
            name="first"
            value={phoneNumber.first}
            onChange={handlePhoneNumberChange}
            style={{ textAlign: "center" }}
          >
            {phoneFirstOptions.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select> */}
        <input
          type="tel"
          name="first"
          value={phoneNumber.first}
          maxLength="3"
          placeholder="000"
          onChange={handleInputChange}
          style={{ textAlign: "center" }}
        />
        {/* </div> */}
        <span className="phoneNumberDash">-</span>
        <input
          type="tel"
          name="second"
          maxLength="4"
          value={phoneNumber.second}
          // onChange={handlePhoneNumberChange}
          ref={secondInputRef}
          onChange={handleInputChange} // 수정된 핸들러 사용
          placeholder="0000"
          style={{ textAlign: "center" }}
        />
        <span className="phoneNumberDash">-</span>
        <input
          type="tel"
          name="third"
          maxLength="4"
          value={phoneNumber.third}
          onChange={handleInputChange}
          placeholder="0000"
          ref={thirdInputRef} // `ref` 연결
          style={{ textAlign: "center" }}
        />
      </div>
    </div>
  );
}

export default PhoneNumberInput;
